module.exports = __webpack_public_path__ + "static/assets/6536d2d814262dd5860b9ff6a89af64e.png";